import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocuments = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 27,
	viewBox: "0 0 22 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.927197 0.928818H15.1643V6.11522C15.1643 6.37077 15.3724 6.57883 15.6296 6.57883H21.0273V26.0694H0.927197V0.928818ZM16.0932 1.55624L20.3409 5.65001H16.0932V1.55624ZM0.463589 27H21.4909C21.7464 27 21.9544 26.7919 21.9544 26.533V6.11522L21.8119 5.77943L15.9572 0.135981L15.9506 0.129421L15.8819 0.085268L15.8065 0.0359955L15.6296 1.90735e-06H0.463589C0.208038 1.90735e-06 0 0.208059 0 0.46361V26.533C0 26.7919 0.208038 27 0.463589 27Z",
			fill: "#272525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.59753 9.91803H17.253C17.3868 9.91803 17.4956 9.77515 17.4956 9.59965C17.4956 9.42415 17.3868 9.28126 17.253 9.28126H4.59753C4.46382 9.28126 4.35498 9.42415 4.35498 9.59965C4.35498 9.77515 4.46382 9.91803 4.59753 9.91803Z",
			fill: "#272525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.2018 12.7879C17.3364 12.7879 17.4452 12.645 17.4452 12.4695C17.4452 12.2929 17.3364 12.15 17.2018 12.15H4.62428C4.48886 12.15 4.38086 12.2929 4.38086 12.4695C4.38086 12.645 4.48886 12.7879 4.62428 12.7879H17.2018Z",
			fill: "#272525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.62768 15.6578H17.2223C17.356 15.6578 17.4649 15.515 17.4649 15.3384C17.4649 15.1629 17.356 15.02 17.2223 15.02H4.62768C4.49312 15.02 4.38428 15.1629 4.38428 15.3384C4.38428 15.515 4.49312 15.6578 4.62768 15.6578Z",
			fill: "#272525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0146 20.7586H4.46314C4.32858 20.7586 4.21973 20.9014 4.21973 21.0769C4.21973 21.2535 4.32858 21.3964 4.46314 21.3964H11.0146C11.1492 21.3964 11.258 21.2535 11.258 21.0769C11.258 20.9014 11.1492 20.7586 11.0146 20.7586Z",
			fill: "#272525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.4613 18.5266H17.2582C17.3928 18.5266 17.5016 18.3837 17.5016 18.2082C17.5016 18.0315 17.3928 17.8887 17.2582 17.8887H4.4613C4.32759 17.8887 4.21875 18.0315 4.21875 18.2082C4.21875 18.3837 4.32759 18.5266 4.4613 18.5266Z",
			fill: "#272525"
		})
	]
});
export { SvgDocuments as ReactComponent };
